import styled from 'styled-components';
import { Icon } from 'ui';

export const StateText = styled.div`
  color: ${p => p.theme.colors.alerts[p.severity]};
  font-weight: ${p => p.theme.fontWeight.bolder};
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;

  > span {
    font-size: 12px;
  }
`;

export const StateIcon = styled(Icon)`
  color: ${p => p.theme.colors.alerts[p.severity]};
`;
